/* raw layout hash: _login-page-layout:d22e74ef7e2ad1293a9f8c4e7b48903b8562d515afa279b8a71760510a4dc297 */
import React from 'react';
import { Outlet } from 'react-router-dom';

/**
 * Unauthenticated shell for the access & identity pages (login / register).
 *
 * The login page is a self-contained, full-viewport hero that brings its own
 * branding, so this shell stays minimal: no fixed-top navbar (it would float
 * over and duplicate the hero's brand) and no spacer footer (it pushed the page
 * past one screen, leaving a blank strip at the bottom). The page owns the full
 * height via <Outlet/>.
 */
export default function LoginPageLayout() {
  return (
    <main className="container-fluid px-0">
      <Outlet />
    </main>
  );
}
